module.exports = __webpack_public_path__ + "static/media/IMG_3274.b45bb71b.JPG";